import { call, put, take } from "redux-saga/effects";
import { actions } from "redux-store";
import { eventChannel } from "redux-saga";

function createNetworkChannel() {
  return eventChannel((emit) => {
    const onlineHandler = () => {
      emit(true);
    };

    const offlineHandler = () => {
      emit(false);
    };

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    const unsubscribe = () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };

    return unsubscribe;
  });
}

/**
 * redux-saga task which continuously dispatches setIsOnline actions as the browser's
 * network status changes. An initial setIsOnline action is dispatched
 * based on `window.navigator.onLine` to establish the initial state.
 */
export function* watchNavigatorStatus() {
  const networkChannel = yield call(createNetworkChannel);

  yield put(actions.setIsOnline(window.navigator.onLine));

  while (true) {
    try {
      const payload = yield take(networkChannel);
      yield put(actions.setIsOnline(payload));
    } catch (err) {
      console.error(err);
    }
  }
}
